import useLocaleText from 'components/useLocaleText'

// Existing keys are verified against TaskCreation/legacy widget and sidebar callsites.
// task_creation_* entries below are new literals absent from those callsites; fallbacks keep the UI readable.
export const creationLiterals = {
  buildTask: {
    key: 'task_creation_build_step_by_step',
    fallback: { en: 'Build your task step by step', he: 'בנו את המשימה צעד אחר צעד' },
  },
  nameFirst: {
    key: 'task_creation_name_first',
    fallback: {
      en: 'Start with the name. Then choose the subtasks your team needs.',
      he: 'התחילו בשם, ואז בחרו את תתי־המשימות לצוות.',
    },
  },
  startBuilding: { key: 'task_creation_start_building', fallback: { en: 'Start building', he: 'התחלת בנייה' } },
  pickType: {
    key: 'task_creation_pick_type_below',
    fallback: { en: 'Pick any subtask type in the bar below', he: 'בחרו סוג תת־משימה בסרגל למטה' },
  },
  addType: { key: 'add', fallback: { en: 'Add', he: 'הוספה' } },
  livePreview: { key: 'task_creation_live_preview', fallback: { en: 'Live preview', he: 'תצוגה מקדימה חיה' } },
  myTasks: { key: 'task_creation_preview_my_tasks', fallback: { en: 'My tasks', he: 'המשימות שלי' } },
  newTask: { key: 'task_creation_preview_new_task', fallback: { en: 'New task', he: 'משימה חדשה' } },
  previewName: { key: 'task_creation_preview_name', fallback: { en: 'Your task name', he: 'שם המשימה שלכם' } },
  noSubtasks: {
    key: 'task_creation_preview_no_subtasks',
    fallback: { en: 'No subtasks yet', he: 'עדיין אין תתי־משימות' },
  },
  teamPreview: {
    key: 'task_creation_team_preview',
    fallback: { en: 'This is what your team in the store will see', he: 'כך הצוות בחנות יראה את המשימה' },
  },
  previewHint: {
    key: 'task_creation_preview_hint',
    fallback: {
      en: 'Name your task, then press Start building to choose subtasks.',
      he: 'תנו שם למשימה ולחצו על התחלת בנייה כדי לבחור תתי־משימות.',
    },
  },
  chooseFirst: {
    key: 'task_creation_choose_first',
    fallback: { en: 'Choose your first subtask', he: 'בחרו את תת־המשימה הראשונה' },
  },
  firstEditorHint: {
    key: 'task_creation_first_editor_hint',
    fallback: {
      en: 'Once you add a subtask, this panel becomes its settings.',
      he: 'לאחר הוספת תת־משימה, ההגדרות שלה יוצגו כאן.',
    },
  },
  moreAttachments: {
    key: 'task_creation_more_attachments',
    fallback: { en: 'more attachments', he: 'קבצים מצורפים נוספים' },
  },
  create: { key: 'create_task_btn', fallback: { en: 'Create task', he: 'יצירת משימה' } },
  categoryHint: {
    key: 'task_creation_category_hint',
    fallback: { en: 'Groups subtasks in reports', he: 'מקבץ תת־משימות בדוחות' },
  },
  categoryEmpty: {
    key: 'task_creation_category_empty',
    fallback: {
      en: 'No categories yet. Create one to reuse across subtasks.',
      he: 'אין קטגוריות עדיין. צרו קטגוריה לשימוש בתת־משימות נוספות.',
    },
  },
  categoryPlaceholder: {
    key: 'task_creation_category_placeholder',
    fallback: { en: 'e.g. Merchandising', he: 'למשל, סידור סחורה' },
  },
  createCategory: { key: 'create', fallback: { en: 'Create', he: 'יצירה' } },
  newCategory: { key: 'add_category', fallback: { en: 'New category', he: 'קטגוריה חדשה' } },
  requiredSubtask: { key: 'is_st_required', fallback: { en: 'Required subtask', he: 'תת־משימה חובה' } },
  requiredHint: {
    key: 'task_creation_required_hint',
    fallback: {
      en: 'The task cannot be completed until this subtask is done.',
      he: 'לא ניתן להשלים את המשימה לפני השלמת תת־משימה זו.',
    },
  },
  questionLabel: { key: 't_questionLabel', fallback: { en: 'Question', he: 'שאלה' } },
  questionHelp: {
    key: 'task_creation_question_help',
    fallback: { en: 'What the executor is asked', he: 'מה נשאל המבצע' },
  },
  answerOptions: { key: 't_optionLabel', fallback: { en: 'Answer options', he: 'אפשרויות תשובה' } },
  addOption: { key: 't_optionPlaceholder', fallback: { en: 'Add option', he: 'הוספת אפשרות' } },
  multipleLabel: { key: 't_multipleAnswers', fallback: { en: 'Allow multiple answers', he: 'אפשר בחירה מרובה' } },
  multipleHint: {
    key: 'task_creation_multiple_hint',
    fallback: { en: 'The executor can select several options.', he: 'המבצע יכול לבחור מספר אפשרויות.' },
  },
  numericLabel: { key: 'is_numeric', fallback: { en: 'Numbers only', he: 'מספרים בלבד' } },
  numericHint: {
    key: 'task_creation_numeric_hint',
    fallback: { en: 'The executor answers with a number.', he: 'המבצע עונה במספר.' },
  },
  photoInstructions: {
    key: 'description',
    fallback: { en: 'Description', he: 'תיבת מידע' },
  },
  videoInstructions: {
    key: 'task_creation_video_instructions',
    fallback: { en: 'What the executor must record', he: 'מה המבצע צריך להקליט' },
  },
  instructionsHint: {
    key: 'task_creation_instructions_hint',
    fallback: { en: 'Written instructions shown to the executor.', he: 'הוראות כתובות שיוצגו למבצע.' },
  },
  referenceImages: {
    key: 'task_creation_reference_images',
    fallback: { en: 'Reference images from you', he: 'תמונות עזר מכם' },
  },
  addPhoto: { key: 't_add_image', fallback: { en: 'Add photo', he: 'הוספת תמונה' } },
  addVideo: { key: 'task_creation_add_video', fallback: { en: 'Add video', he: 'הוספת וידאו' } },
  imageExample: { key: 'task_creation_image_example', fallback: { en: 'Image example', he: 'תמונה לדוגמה' } },
  videoExample: { key: 'task_creation_video_example', fallback: { en: 'Short clip example', he: 'סרטון לדוגמה' } },
  linkTitle: { key: 't_link_title', fallback: { en: 'Link title', he: 'כותרת הקישור' } },
  vm: { key: 'create_vm_task', fallback: { en: 'Create VM task', he: 'יצירת משימת VM' } },
  subtasks: { key: 'subtasks', fallback: { en: 'Subtasks', he: 'תת־משימות' } },
  add: { key: 'add_subtask', fallback: { en: 'Add subtask', he: 'הוספת תת־משימה' } },
  nameYourTask: {
    key: 'task_creation_name_your_task',
    fallback: { en: 'Name your task', he: 'תנו שם למשימה' },
  },
  alreadyAdded: {
    key: 'task_creation_type_already_added',
    fallback: { en: 'Already added to this task', he: 'כבר נוסף למשימה זו' },
  },
  empty: { key: 'task_creation_empty', fallback: { en: 'No subtasks yet', he: 'עדיין אין תת־משימות' } },
  addAnother: {
    key: 'task_creation_add_another_subtask',
    fallback: { en: 'Do you want to add another subtask?', he: 'רוצים להוסיף תת־משימה נוספת?' },
  },
  createdSubtask: {
    key: 'task_creation_created_subtask',
    fallback: { en: 'You created 1 subtask', he: 'יצרתם תת־משימה אחת' },
  },
  createdSubtasks: {
    key: 'task_creation_created_subtasks',
    fallback: { en: 'You created {count} subtasks', he: 'יצרתם {count} תת־משימות' },
  },
  welcome: {
    key: 'task_creation_welcome',
    fallback: { en: 'Build the task from subtasks', he: 'בנו את המשימה מתת־משימות' },
  },
  welcomeHint: {
    key: 'task_creation_welcome_hint',
    fallback: {
      en: 'Choose what the executor needs to do, then fill in the details.',
      he: 'בחרו מה המבצע צריך לעשות, ואז מלאו את הפרטים.',
    },
  },
  editing: { key: 'task_creation_editing', fallback: { en: 'Editing', he: 'בעריכה' } },
  ready: { key: 'task_creation_ready', fallback: { en: 'Ready', he: 'מוכן' } },
  needsAttention: { key: 'task_creation_needs_attention', fallback: { en: 'Needs attention', he: 'דורש השלמה' } },
  untitled: { key: 'task_creation_untitled', fallback: { en: 'Untitled subtask', he: 'תת־משימה ללא כותרת' } },
  optional: { key: 'task_creation_optional', fallback: { en: 'Optional', he: 'אופציונלי' } },
  done: { key: 'done', fallback: { en: 'Done', he: 'סיום' } },
  doneHint: {
    key: 'task_creation_done_hint',
    fallback: { en: 'Done finishes this subtask only', he: 'סיום הגדרת תת־המשימה בלבד' },
  },
  nextShort: { key: 'next', fallback: { en: 'Next', he: 'הבא' } },
  assignStep: { key: 'task_creation_assign_step', fallback: { en: 'Assign', he: 'שיוך' } },
  stepsLabel: { key: 'task_creation_steps', fallback: { en: 'Task creation steps', he: 'שלבי יצירת משימה' } },
  next: { key: 'next', fallback: { en: 'Next: task settings', he: 'הבא: הגדרות המשימה' } },
  addAtLeastOne: {
    key: 't_add_subtasks_empty_screen',
    fallback: { en: 'Add at least one subtask', he: 'הוסיפו לפחות תת־משימה אחת' },
  },
  subtaskCount: {
    key: 'task_creation_subtask_count',
    fallback: { en: 'Subtasks: {count}', he: 'תת־משימות: {count}' },
  },
  subtasksNeedAttention: {
    key: 'task_creation_subtasks_need_attention',
    fallback: { en: '{count} need attention', he: '{count} דורשות טיפול' },
  },
  uploading: {
    key: 'task_creation_uploading',
    fallback: { en: 'Wait for the upload to finish', he: 'המתינו לסיום ההעלאה' },
  },
  cancel: { key: 'cancel', fallback: { en: 'Cancel', he: 'ביטול' } },
  confirmRemove: {
    key: 'task_creation_confirm_remove_subtask',
    fallback: { en: 'Delete subtask?', he: 'למחוק את תת־המשימה?' },
  },
  confirmRemoveHint: {
    key: 'task_creation_confirm_remove_subtask_hint',
    fallback: {
      en: 'This subtask and its content will be removed from the task.',
      he: 'תת־המשימה והתוכן שלה יוסרו מהמשימה.',
    },
  },
  remove: { key: 'delete', fallback: { en: 'Delete', he: 'מחיקה' } },
  reorder: { key: 'task_creation_reorder', fallback: { en: 'Drag to reorder', he: 'גררו לשינוי הסדר' } },
  required: { key: 'required', fallback: { en: 'Required', he: 'חובה' } },
  category: { key: 'category', fallback: { en: 'Category', he: 'קטגוריה' } },
  noCategory: { key: 'task_creation_no_category', fallback: { en: 'Not selected', he: 'לא נבחרה' } },
  back: { key: 'header_button_back', fallback: { en: 'Back to subtasks', he: 'חזרה לתת־משימות' } },
  title: { key: 't_task_title', fallback: { en: 'Task title', he: 'כותרת המשימה' } },
  subtaskTitle: { key: 'create_task_st_title_placeholder', fallback: { en: 'Subtask title', he: 'כותרת תת־המשימה' } },
  instructions: {
    key: 'task_creation_instructions',
    fallback: { en: 'Instructions for the executor', he: 'הוראות למבצע' },
  },
  option: { key: 't_optionLabel', fallback: { en: 'Option', he: 'אפשרות' } },
  options: { key: 'task_creation_options', fallback: { en: 'options', he: 'אפשרויות' } },
  single: { key: 't_select_one', fallback: { en: 'Single choice', he: 'בחירה אחת' } },
  multiple: { key: 't_select_one_or_more', fallback: { en: 'Multiple choice', he: 'בחירה מרובה' } },
  photo: { key: 't_st_image', fallback: { en: 'Photo', he: 'תמונה' } },
  video: { key: 't_st_video', fallback: { en: 'Video', he: 'וידאו' } },
  question: { key: 't_st_open_qst', fallback: { en: 'Text answer', he: 'תשובה בטקסט' } },
  poll: { key: 't_st_poll', fallback: { en: 'Poll', he: 'סקר' } },
  quiz: { key: 't_st_quiz', fallback: { en: 'Quiz', he: 'שאלון' } },
  link: { key: 't_st_link', fallback: { en: 'Link', he: 'קישור' } },
  description: { key: 't_desc', fallback: { en: 'Info box', he: 'תיבת מידע' } },
  ai: { key: 'ai_photo_subtask', fallback: { en: 'AI photo', he: 'תמונת AI' } },
  aiBack: { key: 'header_button_back', fallback: { en: 'Back in AI setup', he: 'חזרה בהגדרת AI' } },
  aiPromptStep: { key: 'task_creation_ai_prompt_step', fallback: { en: '1 / 2 · Prompt', he: '1 / 2 · הנחיות' } },
  aiPreviewStep: {
    key: 'task_creation_ai_preview_step',
    fallback: { en: '2 / 2 · Preview', he: '2 / 2 · תצוגה מקדימה' },
  },
  aiHelper: { key: 'prompt_generator', fallback: { en: 'Prompt generator', he: 'מחולל הנחיות' } },
  aiNext: { key: 'next', fallback: { en: 'Next: preview', he: 'הבא: תצוגה מקדימה' } },
  aiGenerating: { key: 'ai_generating', fallback: { en: 'Generating subtask…', he: 'יצירת תת־משימה…' } },
  aiStepHint: {
    key: 'task_creation_ai_step_hint',
    fallback: { en: 'Configure this AI subtask', he: 'הגדרת תת־משימת AI זו' },
  },
  aiSetupHint: {
    key: 'task_creation_ai_setup_hint',
    fallback: {
      en: 'Finish AI setup or go back to continue editing subtasks.',
      he: 'סיימו את הגדרת ה־AI או חזרו לעריכת תת־המשימות.',
    },
  },
  photoHint: {
    key: 'task_creation_photo_hint',
    fallback: { en: 'Executor takes one or more photos', he: 'המבצע מצלם תמונה אחת או יותר' },
  },
  videoHint: { key: 'task_creation_video_hint', fallback: { en: 'Executor records a video', he: 'המבצע מקליט סרטון' } },
  questionHint: {
    key: 'task_creation_question_hint',
    fallback: { en: 'Executor writes an answer', he: 'המבצע כותב תשובה' },
  },
  pollHint: {
    key: 'task_creation_poll_hint',
    fallback: { en: 'Executor chooses from options', he: 'המבצע בוחר מתוך אפשרויות' },
  },
  quizHint: {
    key: 'task_creation_quiz_hint',
    fallback: { en: 'Executor answers a private poll', he: 'המבצע עונה על סקר פרטי' },
  },
  linkHint: { key: 'task_creation_link_hint', fallback: { en: 'Executor opens a URL', he: 'המבצע פותח קישור' } },
  descriptionHint: {
    key: 'task_creation_description_hint',
    fallback: { en: 'Add instructions, images or files', he: 'הוספת הוראות, תמונות או קבצים' },
  },
  aiHint: {
    key: 'task_creation_ai_hint',
    fallback: { en: 'Set up an AI review of the executor’s photo', he: 'הגדרת בדיקת AI לתמונה של המבצע' },
  },
}

export const missingCreationLiteralKeys = Object.values(creationLiterals)
  .map((definition) => definition.key)
  .filter((key) => key.startsWith('task_creation_'))

export function useCreationText() {
  return useLocaleText(creationLiterals)
}
